<script>
 import { onMount } from "svelte";
 import AwardIcon from "./icons/AwardIcon.svelte"
 import SettingsIcon from "./icons/SettingsIcon.svelte"
 import HelpIcon from "./icons/HelpIcon.svelte"
 import StarIcon from "./icons/StarIcon.svelte"
 import CheckCircleIcon from "./icons/CheckCircleIcon.svelte"
 import CircleIcon from "./icons/CircleIcon.svelte"
 import ClockIcon from "./icons/ClockIcon.svelte"
 import PauseCircleIcon from "./icons/PauseCircleIcon.svelte"
 import { game, GameMode } from "./game.ts";
 export let visible
 export let toggleSettings

 function enableRandom() {
     $game.cmd_reset();
     toggleSettings();
     $game.cmd_sync_url();
 }
 
 function parseData() {
     let wotdData = JSON.parse(localStorage.getItem("SLOVL_WOTD") || "{}")
     let dayByDay = [];
     let max_past_day = $game.dateToDay(new Date());
     for (let d = 1; d <= max_past_day; d++) {
         let s = String(d);
         let attempts = wotdData[s] || [];
         let won = attempts.some(a => a[0] === 1);
         let won_attempts_min = won && attempts.filter(a => a[0] === 1).map(a => a[2]).reduce((a, b) => Math.min(a, b));
         let paused = !won && attempts.some(a => a[0] === 0);
         let not_attempted = !won && !paused;
         dayByDay.push({
             day: s,
             won,
             won_guesses: won_attempts_min,
             paused,
             future: false,
         });
     }
     dayByDay.push({
         future: true,
         day: max_past_day + 1,
     });

     dayByDay.sort((a, b) => b.day - a.day);
     return dayByDay;
 }

 let data = parseData();

 onMount(() => {
     const reparse = () => {
         setTimeout(() => {
             data = parseData();
         }, 100);
     }
     window.addEventListener("storage", reparse);
     return () => {
         window.removeEventListener("storage", reparse);
     };
 });

 function anotherRandom() {
     $game.cmd_anotherRandom();
     toggleSettings();
     $game.cmd_sync_url();
 }

 function linkTo(day) {
     const u = new URL(window.location.href);
     u.search = "?day=" + day;
     return u.toString();
 }

 $: magic = $game.gameStatus !== 0 ? $game.query_hex() : "INIT";

</script>

{#if visible}
    <div class="settings">
        <button on:click={toggleSettings}>К игре</button>
        <div>
            <p>Режим:
                <strong>{$game.currentMode === GameMode.WOTD ? "Словль дня" : "Рандом"}</strong>
                <button on:click={enableRandom}>Рандом</button>
            </p>
            <p>Словарь рандома: <strong>{$game.randomAnswersDictionary.length}</strong></p>
            <p>Мэджик: <strong>{magic}</strong> <button on:click={anotherRandom}>Сменить</button></p>
            <h2>Словль дня</h2>
            <ol class="slovl-days" reversed>
                {#each data as day}
                    <li>
                        {#if day.future}
                            <span title="Откроется завтра!"><ClockIcon /> День {day.day}</span>
                        {:else if day.won}
                            <span title="Взято!"><CheckCircleIcon /> День {day.day}: {day.won_guesses}/6</span>
                        {:else if day.paused}
                            <span title="Всегда можно попробовать ещё раз">
                                <PauseCircleIcon />
                                <a href="{linkTo(day.day)}">День {day.day}</a>
                            </span>
                        {:else}
                            <span><CircleIcon /> <a href="{linkTo(day.day)}">День {day.day}</a></span>
                        {/if}
                    </li>
                {/each}
            </ol>
        </div>
    </div>
{/if}

<style>
 .slovl-days {
     list-style: none;
     padding: 0;

 }

 .slovl-days li + li {
     margin-top: 1rem;
 }

 .settings {
     position: absolute;
     background: #fff8dc;
     top: 0;
     left: 0;
     right: 0;
     bottom: 0;
     z-index: 3;
     padding: 1rem;
     margin: auto;
 }
</style>
